// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* overridden by src/lib/themes/guiHelpers.js */

.ae-features-modal_modal-content_OcnD5 {
  width: 600px;
}

.ae-features-modal_body_Lqi5Z {
  background: var(--ui-modal-background);
  padding: 1.5rem 2.25rem;
  max-height: 75vh;
  overflow: auto;
}

.ae-features-modal_body_Lqi5Z input[type='checkbox'],
.ae-features-modal_body_Lqi5Z input[type='radio'] {
  margin: 3px;
}

.ae-features-modal_text-input_zRC1J {
  margin-bottom: 1rem;
  width: 100%;
  border: 1px solid var(--ui-black-transparent);
  border-radius: 5px;
  padding: 0 1rem;
  height: 3rem;
  color: var(--ui-text-primary-transparent);
  font-size: 0.875rem;
  background-color: var(--input-background);
}

.ae-features-modal_button-row_KHtqt {
  font-weight: bolder;
  text-align: right;
}

.ae-features-modal_button-row_KHtqt button {
  padding: 0.75rem 1rem;
  border-radius: 0.25rem;
  background: white;
  border: 1px solid var(--ui-black-transparent);
  font-weight: 600;
  font-size: 0.85rem;
}

.ae-features-modal_button-row_KHtqt button[disabled] {
  opacity: 0.5;
}

[dir='ltr'] .ae-features-modal_button-row_KHtqt button + button {
  margin-left: 0.5rem;
}

[dir='rtl'] .ae-features-modal_button-row_KHtqt button + button {
  margin-right: 0.5rem;
}

.ae-features-modal_button-row_KHtqt button.ae-features-modal_ok-button_w5D1W {
  background: var(--looks-secondary);
  border: var(--looks-secondary);
  color: white;
}

.ae-features-modal_button-row_KHtqt button.ae-features-modal_cancel-button_Gk21Z {
  color: black;
}

.ae-features-modal_help-text_XndMc {
  margin-bottom: 1rem;
}

.ae-features-modal_must-change_OPzGk {
  font-weight: bold;
}

.ae-features-modal_reset-link_BWgZV {
  cursor: pointer;
}

.ae-features-modal_header_poLXI {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 0.5rem 0 0 0;
  font-weight: bold;
}

.ae-features-modal_divider_vwxdi {
  flex-grow: 1;
  margin-left: 1rem;
  border-top: 1px dashed var(--ui-tertiary);
}

.ae-features-modal_hr_TtrjX {
  opacity: 0.2;
}

.ae-features-modal_logo_BdDqk {
  width: 60%;
  display: flex;
  justify-content: center;
  margin: 0 auto;
}

.ae-features-modal_title_Mn6aX {
  text-align: center;
}

.ae-features-modal_intro_MIHeF {
  text-align: center;
}

.ae-features-modal_linkDiv_MVDPh {
  border-radius: 5px;
  margin: 10px;
  padding: 10px;
  display: flex;
  flex-direction: column;
}

.ae-features-modal_linkDivContent_pfWbl {
  border: none;
  background: var(--ui-secondary);
  color: var(--text-primary);
  padding: 10px;
  border-radius: 5px;
  font-weight: bold;
  cursor: pointer;
  width: 100%;
  margin: 5px 0;
  transition: filter 0.15s ease;
}

.ae-features-modal_linkDivContent_pfWbl:hover {
  filter: brightness(0.8);
}

.ae-features-modal_backIcon_3iK2t {
  width: 25px;
  height: 25px;
  filter: drop-shadow(0 0 5px #55555580);
}

.ae-features-modal_backButton_fpYiK {
  position: absolute;
  background-color: #ffffff00;
  border: none;
}

.ae-features-modal_dorpdownIcon_KwZiD {
  width: 15px;
  height: 15px;
  filter: drop-shadow(0 0 5px #55555580);
}
`, "",{"version":3,"sources":["webpack://./src/components/ae-features-modal/ae-features-modal.css"],"names":[],"mappings":"AAAA,+CAA+C;;AAE/C;EACE,YAAY;AACd;;AAEA;EACE,sCAAsC;EACtC,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,6CAA6C;EAC7C,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,yCAAyC;EACzC,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;EACjB,6CAA6C;EAC7C,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kCAAkC;EAClC,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,yCAAyC;AAC3C;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;EACV,aAAa;EACb,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,+BAA+B;EAC/B,0BAA0B;EAC1B,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sCAAsC;AACxC","sourcesContent":["/* overridden by src/lib/themes/guiHelpers.js */\n\n.modal-content {\n  width: 600px;\n}\n\n.body {\n  background: var(--ui-modal-background);\n  padding: 1.5rem 2.25rem;\n  max-height: 75vh;\n  overflow: auto;\n}\n\n.body input[type='checkbox'],\n.body input[type='radio'] {\n  margin: 3px;\n}\n\n.text-input {\n  margin-bottom: 1rem;\n  width: 100%;\n  border: 1px solid var(--ui-black-transparent);\n  border-radius: 5px;\n  padding: 0 1rem;\n  height: 3rem;\n  color: var(--ui-text-primary-transparent);\n  font-size: 0.875rem;\n  background-color: var(--input-background);\n}\n\n.button-row {\n  font-weight: bolder;\n  text-align: right;\n}\n\n.button-row button {\n  padding: 0.75rem 1rem;\n  border-radius: 0.25rem;\n  background: white;\n  border: 1px solid var(--ui-black-transparent);\n  font-weight: 600;\n  font-size: 0.85rem;\n}\n\n.button-row button[disabled] {\n  opacity: 0.5;\n}\n\n[dir='ltr'] .button-row button + button {\n  margin-left: 0.5rem;\n}\n\n[dir='rtl'] .button-row button + button {\n  margin-right: 0.5rem;\n}\n\n.button-row button.ok-button {\n  background: var(--looks-secondary);\n  border: var(--looks-secondary);\n  color: white;\n}\n\n.button-row button.cancel-button {\n  color: black;\n}\n\n.help-text {\n  margin-bottom: 1rem;\n}\n\n.must-change {\n  font-weight: bold;\n}\n\n.reset-link {\n  cursor: pointer;\n}\n\n.header {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  margin: 0.5rem 0 0 0;\n  font-weight: bold;\n}\n\n.divider {\n  flex-grow: 1;\n  margin-left: 1rem;\n  border-top: 1px dashed var(--ui-tertiary);\n}\n\n.hr {\n  opacity: 0.2;\n}\n\n.logo {\n  width: 60%;\n  display: flex;\n  justify-content: center;\n  margin: 0 auto;\n}\n\n.title {\n  text-align: center;\n}\n\n.intro {\n  text-align: center;\n}\n\n.linkDiv {\n  border-radius: 5px;\n  margin: 10px;\n  padding: 10px;\n  display: flex;\n  flex-direction: column;\n}\n\n.linkDivContent {\n  border: none;\n  background: var(--ui-secondary);\n  color: var(--text-primary);\n  padding: 10px;\n  border-radius: 5px;\n  font-weight: bold;\n  cursor: pointer;\n  width: 100%;\n  margin: 5px 0;\n  transition: filter 0.15s ease;\n}\n\n.linkDivContent:hover {\n  filter: brightness(0.8);\n}\n\n.backIcon {\n  width: 25px;\n  height: 25px;\n  filter: drop-shadow(0 0 5px #55555580);\n}\n\n.backButton {\n  position: absolute;\n  background-color: #ffffff00;\n  border: none;\n}\n\n.dorpdownIcon {\n  width: 15px;\n  height: 15px;\n  filter: drop-shadow(0 0 5px #55555580);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal-content": `ae-features-modal_modal-content_OcnD5`,
	"modalContent": `ae-features-modal_modal-content_OcnD5`,
	"body": `ae-features-modal_body_Lqi5Z`,
	"text-input": `ae-features-modal_text-input_zRC1J`,
	"textInput": `ae-features-modal_text-input_zRC1J`,
	"button-row": `ae-features-modal_button-row_KHtqt`,
	"buttonRow": `ae-features-modal_button-row_KHtqt`,
	"ok-button": `ae-features-modal_ok-button_w5D1W`,
	"okButton": `ae-features-modal_ok-button_w5D1W`,
	"cancel-button": `ae-features-modal_cancel-button_Gk21Z`,
	"cancelButton": `ae-features-modal_cancel-button_Gk21Z`,
	"help-text": `ae-features-modal_help-text_XndMc`,
	"helpText": `ae-features-modal_help-text_XndMc`,
	"must-change": `ae-features-modal_must-change_OPzGk`,
	"mustChange": `ae-features-modal_must-change_OPzGk`,
	"reset-link": `ae-features-modal_reset-link_BWgZV`,
	"resetLink": `ae-features-modal_reset-link_BWgZV`,
	"header": `ae-features-modal_header_poLXI`,
	"divider": `ae-features-modal_divider_vwxdi`,
	"hr": `ae-features-modal_hr_TtrjX`,
	"logo": `ae-features-modal_logo_BdDqk`,
	"title": `ae-features-modal_title_Mn6aX`,
	"intro": `ae-features-modal_intro_MIHeF`,
	"linkDiv": `ae-features-modal_linkDiv_MVDPh`,
	"linkDivContent": `ae-features-modal_linkDivContent_pfWbl`,
	"backIcon": `ae-features-modal_backIcon_3iK2t`,
	"backButton": `ae-features-modal_backButton_fpYiK`,
	"dorpdownIcon": `ae-features-modal_dorpdownIcon_KwZiD`
};
export default ___CSS_LOADER_EXPORT___;
